import type { SVGAttributes } from 'react';

export function FilterCategoryIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<rect width="24" height="24" rx="4" fill="currentColor" fillOpacity="0.1" />
			<path
				d="M12.4135 17.8733C12.1868 17.9533 11.8135 17.9533 11.5868 17.8733C9.6535 17.2133 5.3335 14.46 5.3335 9.79335C5.3335 7.73335 6.9935 6.06668 9.04016 6.06668C10.2535 6.06668 11.3268 6.65335 12.0002 7.56001C12.6735 6.65335 13.7535 6.06668 14.9602 6.06668C17.0068 6.06668 18.6668 7.73335 18.6668 9.79335C18.6668 14.46 14.3468 17.2133 12.4135 17.8733Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
